import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum WorkflowType {
    HANDOUT_EVENT_PLANNING = 'handoutEventPlanning',
    AVAILABILITIES_UPDATE_CONTRADICTION = 'availabilitiesUpdateContradiction',
    ABSENCE_EARLY_WARNING = 'absenceEarlyWarning',
}

export namespace WorkflowType {
    type Data = {
        text: string;
        shortDescription: string;
        longDescription: string;
    }

    export const Record: Record<WorkflowType, Data> = {
        [WorkflowType.HANDOUT_EVENT_PLANNING]: {
            text: 'Planung von Austeilaktionen',
            shortDescription: 'Dieser Workflow gleicht Termine mit Lehrkräften und Standorten ab, um Austeilaktionen zu planen.',
            longDescription: `Dieser Workflow dient der Planung von Austeilaktionen.
            Er kontaktiert selbstständig Lehrkräfte und Standorte, um Termine abzugleichen und legt die Austeilaktionen direkt an.`,
        },
        [WorkflowType.AVAILABILITIES_UPDATE_CONTRADICTION]: {
            text: 'Widersprüche bei Verfügbarkeitsaktualisierungen',
            shortDescription: 'Dieser Workflow behandelt Widersprüche bei Verfügbarkeitsaktualisierungen.',
            longDescription: 'Dieser Workflow prüft, ob es bei Verfügbarkeitsaktualisierungen Widersprüche mit dem Kursplan gibt. Es können Verantwortliche benannt werden, die ein To-Do erhalten, wenn ein Widerspruch auftritt.',
        },
        [WorkflowType.ABSENCE_EARLY_WARNING]: {
            text: 'Frühwarnung bei Abwesenheiten',
            shortDescription: 'Fehlt ein Kind mehrmals, bekommt die QM-Zuständige des Bundeslands ein To-do und die Familie auf Wunsch eine freundliche Nachfrage.',
            longDescription: 'Dieser Workflow wertet werktags die Kursprotokolle aus (Fehlen in Folge oder X von Y Stunden). Löst die Regel aus, erhält die QM-Zuständige des Bundeslands (sonst die Standard-Supervisor:in) ein To-do, die Eltern optional eine Mail im Namen der QM-Zuständigen und das Kind einen Protokolleintrag. Pro Kind gilt eine Ruhezeit.',
        },
    };

    export const Items = mapRecordToItems(Record);
}
